import React, { useState, useEffect } from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader';
import Footer from '../components/Footer/Footer';
import { useDispatch, useSelector } from 'react-redux';
import ReactInputVerificationCode from 'react-input-verification-code';
import { VerifyEmailAddressAPI, VerifyOtpAPI } from '../redux/slices/VerifyOTP';
import { errorHandler } from '../constants/base';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const EmailVarificationForSignUp = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const newUser = useSelector(state => state.UserSignUp.newUser)
    const emailThatReject = useSelector(state => state?.AuthSlice?.emailThatReject)

    const verifyEmailAddress = async () => {
        try {
            const res = await dispatch(VerifyEmailAddressAPI(newUser?.id || emailThatReject?.user_id))

            if (res.type === 'VerifyEmailAddressAPI/fulfilled') {
                if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                    // toast.success("Email Verified Successfully");
                    navigate("/signin");
                } else {
                    errorHandler(res.payload.errors);
                }
            } else if (res.type === 'VerifyEmailAddressAPI/rejected') {
                errorHandler(res.payload.errors);
            } else {
                toast.error('Sorry, something went wrong!');
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleComplete = async (value) => {
        const verifyOTPData = {
            email: newUser?.email || emailThatReject?.email,
            otp: value
        }
        const res = await dispatch(VerifyOtpAPI(verifyOTPData));

        if (res.type === 'VerifyOtpAPI/fulfilled') {
            if (res?.payload?.status === 200) {
                verifyEmailAddress();
            }
        } else if (res.type === 'VerifyOtpAPI/rejected') {
            toast.error("Invalid OTP. Please try again.")
        } else {
            toast.error('Sorry, something went wrong!');
        }
    }

    // // ONE MINUTE TIMER
    // const [timeLeft, setTimeLeft] = useState(() => {
    //     const storedTime = localStorage.getItem('otpTimer');
    //     if (storedTime) {
    //         const now = Date.now();
    //         const timeRemaining = Math.max(0, Number(storedTime) - now);
    //         return Math.ceil(timeRemaining / 1000);
    //     }
    //     return 60;
    // });

    // useEffect(() => {
    //     if (timeLeft <= 0) {
    //         localStorage.removeItem('otpTimer');
    //         return;
    //     }
    //     const expirationTime = Date.now() + timeLeft * 1000;
    //     localStorage.setItem('otpTimer', expirationTime);

    //     const interval = setInterval(() => {
    //         setTimeLeft((prevTime) => {
    //             const newTime = prevTime - 1;
    //             if (newTime <= 0) {
    //                 clearInterval(interval);
    //                 localStorage.removeItem('otpTimer');
    //             }
    //             return newTime;
    //         });
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, [timeLeft]);

    // const formatTime = (seconds) => {
    //     const mins = Math.floor(seconds / 60);
    //     const secs = seconds % 60;
    //     return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    // };

    // const handleResendOtp = async () => {
    //     const emailData = {
    //         email: localStorage.getItem("forgotEmailAddress"),
    //     };
    //     // const res = await dispatch(forgotPasswordAPI(emailData))
    //     // if (res?.payload?.status === 200) {
    //     //     setTimeLeft(60);
    //     // }
    // };

    return (
        <>
            <SecondHeader />
            <div className="varificaion-box-main">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="home-banner-text">
                                <h1>Verification OTP</h1>
                                <p className="common-text">Enter the verification OTP that we have
                                    sent to your email</p>
                            </div>

                            <div className="varification-code-boxes">
                                <ReactInputVerificationCode placeholder='' style={{
                                    borderColor: "#5658f6",
                                }} onCompleted={handleComplete} />
                            </div>

                            {/* <h1 className='resend-otp-text'>
                                Resend OTP in {formatTime(timeLeft)}
                            </h1> */}

                            {/* <div className='resend-otp-container'>
                                {timeLeft > 0 ? (
                                    <h1 className='resend-otp-text'>
                                        Resend OTP in {formatTime(timeLeft)}
                                    </h1>
                                ) : (
                                    <div className="submit-btn-form mt-4">
                                        <button className="btn btn-primary" onClick={handleResendOtp}>Resend OTP</button>
                                    </div>
                                )}
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default EmailVarificationForSignUp